// src/app/change-log/change-log.component.ts
import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

let self: any;

@Component({
  selector: 'app-change-log',
  templateUrl: './change-log.component.html',
  styleUrls: ['./change-log.component.css']
})
export class ChangeLogComponent implements OnInit {
  @Input() log: any;
  @Input() logIndex!: number;
  @Input() totalLogs!: number;
  @Input() navigate!: (step: number) => void;

  dialog: MatDialogRef<any>;
  changes: { entity: string; before: any; after: any }[] = [];
  properties: { [key: string]: 'added' | 'removed' | 'modified' | 'unchanged' }[] = [];
  date!: Date;
  user: any;
  company: any;
  action!: string;
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<any>
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit(): void {
    this.updateLogDetails();
  }

  updateLogDetails() {
    this.date = this.log.updatedAt;
    this.user = this.log.user;
    this.company = this.log.company;
    this.action = this.log.action;
    this.changes = this.log.changes;
    this.calculateProperties();
  }

  calculateProperties() {
    this.properties = this.changes.map(change => this.calculateChangeProperties(change.before, change.after));
  }

  calculateChangeProperties(before: any, after: any): { [key: string]: 'added' | 'removed' | 'modified' | 'unchanged' } {
    const beforeKeys = before ? Object.keys(before) : [];
    const afterKeys = after ? Object.keys(after) : [];
    const allKeys = Array.from(new Set([...beforeKeys, ...afterKeys]));

    const keyChanges: any = {};
    allKeys.forEach((key: any) => {
      if (typeof before?.[key] === 'object' && before?.[key] !== null || typeof after?.[key] === 'object' && after?.[key] !== null) {
        const nestedChanges = this.calculateChangeProperties(before?.[key], after?.[key]);
        for (const nestedKey in nestedChanges) {
          keyChanges[`${key}.${nestedKey}`] = nestedChanges[nestedKey];
        }
      } else if (!before || !(key in before)) {
        keyChanges[key] = 'added';
      } else if (!after || !(key in after)) {
        keyChanges[key] = 'removed';
      } else if (before[key] !== after[key]) {
        keyChanges[key] = 'modified';
      } else {
        keyChanges[key] = 'unchanged';
      }
    });

    return keyChanges;
  }

  getChangeType(changeDetail: any, key: string): 'added' | 'removed' | 'modified' | 'unchanged' {
    return changeDetail[key];
  }

  getValue(obj: any, path: string): any {
    return path.split('.').reduce((o, p) => o ? o[p] : undefined, obj);
  }
}
